/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
var ContentRef = (function () {
    function ContentRef(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
    return ContentRef;
}());
export { ContentRef };
//# sourceMappingURL=content-ref.class.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/component-loader/content-ref.class.js
// module id = 570
// module chunks = 0